import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { InputX, InputRed } from 'components'
import styles from './index.module.css'

const CompanyMain = () => {

	const App = useApp()
	const [tabMenu, setTabMenu] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className={styles["l-title"]}>김모니님 궁금한 회사가 있나요?</div>
				<p className="guide-title mt_20">회사의 기본정보부터 재무분석 정보까지<br />간단하게 조회하세요!</p>

				<ul className="tab-round-box mt_40">
					<li onClick={() => setTabMenu(0)} className={tabMenu === 0 ? "on" : ""}>회사명</li>
					<li onClick={() => setTabMenu(1)} className={tabMenu === 1 ? "on" : ""}>사업자 등록번호</li>
				</ul>

				<div className="form-group search-bar mt_30">
					<InputX type="text" placeholder="회사정보를 입력해보세요." id="" />
					<i className="icon icon_search" />
				</div>
				<InputRed show={true} text="검색어는 최소 1글자 이상 입력해주세요." />
			</div>

			<div className={`${styles["l-title"]} padding pb_20`}>최근 검색어</div>
			<div className="no-scroll pb_30" style={{ overflowX: "auto" }}>
				<ul className={styles["search-word"]}>
					<li><span>모니</span><i className="icon" /></li>
					<li><span>주식회사 모니</span><i className="icon" /></li>
					<li><span>1234567890</span><i className="icon" /></li>
					<li><span>주식회사모니모</span><i className="icon" /></li>
					<li><span>주식회사모니모니</span><i className="icon" /></li>
				</ul>
			</div>

			<div className="slider padding pt_20 pb_50 mt_20">
				<ul>
					<li>
						<div className={`${styles["company-guide-box"]} center-cont`}>
							<h3 className="intro-tit">회사명과 사업자등록번호로<br />쉽게 조회해요!</h3>
							<span className="guide-title mt_20">회사 설립일, 사원수, 주요사업 등<br />정보를 한 번에 알 수 있어요!</span>
							<i className="icon icon_other_search mt_50" style={{ width: "13rem", height: "11rem" }} />
						</div>
					</li>
					{/* <li>
							<div className={`${styles["company-guide-box"]} center-cont`}>
								<h3 className="intro-tit">최신 결산자료로<br />재무상태 변동 내역 확인</h3>
								<span className="guide-title mt_20">유동자산/비유동자산의 비율과<br />부채와 자본 비율까지 확인하세요!</span>
								<i className="icon icon_info_object mt_50" style={{ width: "15rem", height: "10.8rem" }} />
							</div>
						</li> */}
				</ul>
				<ul className="slider-dots dots-gray mt_20" style={{ position: "absolute", right: "2rem", top: "-2rem" }}>
					<li className="active" />
					<li />
				</ul>
			</div>
		</div>
	)
}

export default CompanyMain